import { render, staticRenderFns } from "./BusinessUnitEdit.vue?vue&type=template&id=1e51d800&"
import script from "./BusinessUnitEdit.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports